<div *ngIf="isLoggedOrLogin()">
    <div class="app-header">
        <div style="margin-left: 3%;">{{ roleTitle }}</div>
        <span class="spacer"></span>
        <div class="navbar-right">
            <div style="height: 20px;">Certificates - {{version_back}} / {{version_front}}</div>
            <div style="height: 10px;">Copyright {{year}} Prosegur</div>
        </div>
    </div>
    <app-sidebar ></app-sidebar>
</div>

<div class="contentBody" [ngClass]="{'no-opacity':hideContent(), 'noLogin':isLoggedOrLogin(), 'menuOpen': menuOpen}">
    <router-outlet></router-outlet>
</div>
<ngx-ui-loader></ngx-ui-loader>